import React from 'react'
import Header from "../components/layout/Header"
import Profile from "../components/blocks/Profile"
import classes from "../components/layout/Layout/Layout.module.scss"

export default function ProfilePage() {
  return (
    <>
      <div className={classes.header}>
        <Header/>
      </div>
      <div className={classes.content}>
        <Profile/>
      </div>
    </>
  )
}